import { Company } from "@finway-group/shared/lib/models"
import { Dispatch } from "redux"
import { AuthService, CompanyService, LocalStorageService } from "Shared/services"
import { COMPANY_ID } from "../../../services/localstorage.service"
import { resetCardOverviewData } from "../analytics/analyticsActions"
import { resetWallet } from "../corporate/corporateActions"
import { resetCostCenter, setCostCenter } from "../costCenter/costCenterActions"
import { resetImportResults } from "../import/importActions"
import { resetLiquidities } from "../liquidity/liquidityActions"

import { resetAllTables } from "../tables/tableActions"
import { CompanyActionTypes, CreateCompanyAction, FetchAllCompaniesAction, MarkCompanyAsDeletedAction, SelectCompanyAction, UpdateCompanyAction } from "./companyTypes"

export const updateCompany = (updatedCompany: Company) => async (dispatch: Dispatch) => {
    const company = await CompanyService.updateCompany(updatedCompany)
    const updateCompanyAction: UpdateCompanyAction = {
        type: CompanyActionTypes.UPDATE_COMPANY,
        company,
    }

    dispatch(updateCompanyAction)
    return company
}

export const fetchAllCompanies =
    (shouldRefetch: boolean = true) =>
    async (dispatch: Dispatch) => {
        // temporary until we update shared to include id instead of _id
        const companies = await CompanyService.fetchCompanies()

        const selectedCompanyId = LocalStorageService.get(COMPANY_ID)
        let selectedCompany = {} as Company

        if (!selectedCompanyId) {
            LocalStorageService.setCompanyId(companies[0]._id)
            selectedCompany = companies[0] as Company
        } else {
            selectedCompany = companies.filter((company: Company) => company._id === selectedCompanyId)?.[0]
            if (!selectedCompany) {
                LocalStorageService.setCompanyId(companies[0]._id)
                selectedCompany = companies[0] as Company
            }
        }

        const fetchAllCompaniesAction: FetchAllCompaniesAction = {
            type: CompanyActionTypes.FETCH_ALL_COMPANIES,
            companies,
            company: { ...selectedCompany, shouldRefetch },
        }

        dispatch(fetchAllCompaniesAction)
        return companies
    }

export const createCompany = (newCompany: Company) => async (dispatch: Dispatch) => {
    const company = await CompanyService.createCompany(newCompany)

    const createCompanyAction: CreateCompanyAction = {
        type: CompanyActionTypes.CREATE_COMPANY,
        company,
    }

    await AuthService.setCurrentCompany(company._id)

    dispatch(createCompanyAction)
    return company
}

export const selectCompany = (company: Company) => async (dispatch: Dispatch) => {
    const selectCompanyAction: SelectCompanyAction = {
        type: CompanyActionTypes.SELECT_COMPANY,
        company,
    }

    await AuthService.setCurrentCompany(company._id)

    dispatch(selectCompanyAction)

    dispatch(resetAllTables())
    dispatch(resetImportResults())
    // reset cost center item
    dispatch(resetCostCenter())
    resetLiquidities()(dispatch)
    resetWalletInformation()(dispatch)
    LocalStorageService.unsetWeavrToken()

    if (company._id) LocalStorageService.setCompanyId(company._id)

    return company
}

export const resetWalletInformation = () => async (dispatch: Dispatch) => {
    resetWallet()(dispatch)
    resetCardOverviewData()(dispatch)
}

export const markCompanyAsDeleted = (id: string) => async (dispatch: Dispatch) => {
    const deletedCompany = await CompanyService.deleteCompany(id)
    const markCompanyAsDeletedAction: MarkCompanyAsDeletedAction = {
        type: CompanyActionTypes.MARK_AS_DELETED,
        company: deletedCompany,
    }

    dispatch(markCompanyAsDeletedAction)
    return deletedCompany
}

export const setCompany = (company: Company) => async (dispatch: Dispatch) => {
    const updateCompanyAction: UpdateCompanyAction = {
        type: CompanyActionTypes.UPDATE_COMPANY,
        company,
    }

    dispatch(updateCompanyAction)
    return company
}
